import { localStorage, sessionStorage } from 'dibs-browser-storage';
import SV from 'server-vars';

import isPageType from '../../../utils/isPageType';
import { PAGE_TYPE } from '../../../utils/pageConstants';
import { MODAL_ID, NUM_TIMES_TO_SHOW } from './constants';

function markModalSeen() {
    if (sessionStorage) {
        sessionStorage.setItem(MODAL_ID, true);
    }
    if (localStorage) {
        let modalStorage = localStorage.getItem(MODAL_ID);
        if (modalStorage) {
            modalStorage.totalViewCount++;
        } else {
            modalStorage = {
                totalViewCount: 1,
            };
        }
        localStorage.setItem(MODAL_ID, modalStorage);
    }
}

function hasSeenModal() {
    if (sessionStorage && localStorage) {
        const modalStorage = localStorage.getItem(MODAL_ID) || {};
        return (
            !!sessionStorage.getItem(MODAL_ID) || modalStorage.totalViewCount >= NUM_TIMES_TO_SHOW
        );
    }
    return false;
}

export default function workspaceIntroRule() {
    const isUserTypeTrade = SV.get('settings.isUserTypeTrade') || false;
    const isBlacklistedPage = isPageType([
        PAGE_TYPE.CHECKOUT,
        PAGE_TYPE.CHECKOUT_CONFIRMATION,
        PAGE_TYPE.ORDER_MANAGER,
    ]);
    const shouldOpenModal = isUserTypeTrade && !isBlacklistedPage && !hasSeenModal();
    if (shouldOpenModal) {
        markModalSeen();
    }

    return Promise.resolve(shouldOpenModal);
}
